import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function SocialEvents() {
  return (
    <>
      <PageHero
        eyebrow="Participant info"
        title="Social events"
        intro="Information about social events at EAC2027 will be published here as soon as the programme is confirmed."
      />

      <main className="info-page py-5">
        <Container>
          <Row className="justify-content-center mt-5">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className='h1'>Programme</h2>
                
                <p className="info-note">Please check this page again later for updates.</p>
              </section>
            </Col>
          </Row>
        </Container>
      </main>

    </>
  );
}
